<template>
  <!-- <div v-if="$store.state.auth.status.loggedIn"> -->
    <!-- 추가된 헤더 컴포넌트 사용 -->

    <!-- {{$store.state.auth.shelterAccount}} -->
    <Header v-if="$store.state.auth.status.loggedIn"></Header>
    <div style="min-height:83vh;">
      <router-view/>
    </div>
    <!-- 추가된 풋터 컴포넌트 사용 -->
    <Footer></Footer>
  <!-- </div> -->
  <!-- <LoginView v-else/> -->
  <ConfirmDialog :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '20vw'}"></ConfirmDialog>
  <ImagePickerModal />
  <VideoPickerModal />

  <loading 
        :active="isLoading" 
        :can-cancel="true" 
        :color="'#f6951c'"
        :loader="'bars'"
        :z-index="9999"
        ></loading>
</template>

<script>

// @ is an alias to /src
// import ShelterLogin from '@/components/ShelterLogin.vue'
import Header from './components/common/Header.vue'; //import 헤더 추가
import Footer from './components/common/Footer.vue'; //import 풋터 추가
import HomeView from './views/HomeView';
import LoginView from '@/views/account/Login.vue';
import ConfirmDialog from 'primevue/confirmdialog';
import ImagePickerModal from '@/components/common/ImagePickerModal.vue';
import VideoPickerModal from '@/components/common/VideoPickerModal.vue';
// import html2canvas from 'html2canvas'

// Import the method.
import Loading from 'vue3-loading-overlay';
// Import stylesheet
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import moment from 'moment';

// import 'bootstrap/dist/js/bootstrap.esm.min.js'

// import 'bootstrap/dist/js/bootstrap';
// import 'bootstrap/dist/css/bootstrap.css'


export default {
  name: 'HomeView',

  components: {
    Header, Footer, HomeView, LoginView, ConfirmDialog, Loading, ImagePickerModal, VideoPickerModal,
  },
  data() {
    return {

      image_server : process.env.VUE_APP_IMAGE_SERVER,
      video_server : process.env.VUE_APP_VIDEO_SERVER,

      shelter : {},
      ip : "",

      isLogin : false,
      isLoading : false,

      isAdmin : false,

      //관리자 메뉴
      admin : {
        shelterList : [],
      },
    }
  },
  methods: {

    reloadAccount(){
        // if(!this.$store.state.auth.shelterAccount){
        const auth_token = JSON.parse(localStorage.getItem('auth_token'));

        if(auth_token != null && auth_token.shelterAccount){
            this.shelter = auth_token.shelterAccount;

            if(this.shelter.shelter_device_number == 'admin@pasm.kr'){
            console.log("어드민");

            this.isAdmin = true;

            this.admin.shelterList = JSON.parse(localStorage.getItem('shelter_list'));
            }else{
            this.isAdmin = false;
            }
        }else{

        }
        // console.log("local : " + this.shelter);
        // }
        // else{
        //   this.shelter = this.$store.state.auth.shelterAccount;

        //   console.log("store : " + this.shelter);
        // }


    },

    loadingStart(){
      this.isLoading = true;
    },
    loadingStop(){
      this.isLoading = false;
    },

    showToastMsg(icon, title, msg, time){
    if(time == 'default' | time == ''){
    time = 5000;
    }

    this.$toast.show(
        "<div class='row'>" +
            "<div class='col-2' style='display: grid;align-items: center;'>" +
                "<i class='bi bi-check-circle-fill' style='color : #198754; font-size: 1.4rem;'></i>" +
            "</div>" +
            "<div class='col-10' style='padding:0'>" +
                "<div class='row'><p class='mb-0' style='font-size:12px;color : #000; font-weight:600;'>"+ title +"</p></div>" +
                "<div class='row'><p class='mb-0' style='font-size:12px;color : #333;'>"+ msg +"</p></div>" +
            "</div>" +
        "</idv>",
        {
            position:"top-right",
            duration:time,
        });
    },

    modalCloseAlert(modalId){
        let result = confirm('종료하시겠습니까? 작성중이던 데이터는 저장되지 않습니다.');
        if(result){

            // console.log(modalId)
            document.getElementById(modalId).click();
        }else{

        }
    },

    insertAccessLog(type, page_name, processing_information, download_reason){
      let me = this;
      let log = {};

      log.shelter = this.shelter.shelter_device_number;
      log.type = type;
      log.page_name = page_name;
      log.download_reason = download_reason;
      log.processing_information = processing_information;

      // console.log(log.ip);

      let config = {
          "headers": {
              "Content-Type": "multipart/form-data",
          }
      };

      const formData = new FormData();

      formData.append("pasmAccessLog", this.$common.convertFormData(log));

      this.axios.post('/log', formData, config)
          .then(function (res) {

          }).catch(function (error) {
              me.$root.loadingStop();

              console.log(error);
              alert('등록 에러');
      });
    }

  },
  mounted(){
  },
  created (){
    if(!this.$store.state.auth.status.loggedIn){
      this.$router.push('/login');
    }

    this.reloadAccount();
  },
  computed(){

  }
  
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
  }
}

.c-toast{
    color : #333 !important;
    padding: 0.5em 1rem !important;
    background-color: #ffffff !important;
    border : 1px solid #a9a9a9;
    box-shadow: 1px 1px 1px #ededed;
    min-width: 20%;
    min-height: 4em !important;
}
.p-dialog .p-dialog-footer {
  border-top : 0 !important;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
